import { lazy } from 'react'

const NetworkTopology = {
  Container: lazy(() => import('./Container')),
}

export default NetworkTopology